<template>
    <div class="w-full">
        <div class="mt-10 flex flex-row items-center justify-between">
            <div class="text-black text-lg font-semibold ">
                {{ GET_SLIDE.name }}
            </div>
            <counter :endTime="GET_SLIDE.minutes * 60" />
        </div>
        <div
            class="w-full  mt-8 "
            v-for="(question, index) in GET_SLIDE.testQuestions"
            :key="index"
        >
            <p
                class="text-base  whitespace-pre-line mb-3 font-semibold transition-colors"
                :class="
                    state.wrongQuestionIds.includes(question.id)
                        ? 'text-red'
                        : 'text-black'
                "
            >
                {{ question.question }}
            </p>
            <input-checkbox
                v-for="(options, index) in question.testQuestionAnswers"
                :key="options.id"
                class="mb-4"
                :name="`question-option-${index}`"
                :id="`question-option-${index}`"
                :modelValue="options.result[0]?.is_passed ?? false"
                :defaultColor="'grey'"
                :label="options.answer"
                :activeColor="'primary'"
                @change="handleCheckboxChange(options)"
            />
        </div>
        <custom-button
            @click="UPDATE_TEST_QUESTIONS"
            class="w-72 h-11 mt-10"
            :text="'Test bewerten'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'test-finished-button'"
        />
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../../../common/dataHelper";
import Counter from "../../../../components/helper/Counter.vue";
import CustomButton from "../../../../components/input/CustomButton.vue";
import InputCheckbox from "../../../../components/input/InputCheckbox.vue";
import {
    HELPER_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../../store/types";
export default defineComponent({
    components: {
        Counter,
        InputCheckbox,
        CustomButton,
    },
    name: "Test",
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({
            wrongQuestionIds: [],
        });
        /**
         *  Functions
         */

        async function UPDATE_TEST_QUESTIONS() {
            state.wrongQuestionIds = [];
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "test-finished-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.UPDATE_TEST_QUESTIONS}`,
                {
                    slide: GET_SLIDE.value,
                }
            );
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "test-finished-button"
            );
            const result = getData(
                response,
                "data.customerTestResults.is_finished"
            );
            if (result == false) {
                store.commit(
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_TOAST_MESSAGE}`,
                    "Manche Fragen wurden falsch beantwortet."
                );
                const wrongQuestions = getData(
                    response,
                    "data.customerTestResults.wrongQuestions"
                );
                wrongQuestions.forEach((q) => {
                    state.wrongQuestionIds.push(q.id);
                });
            }
        }
        function handleCheckboxChange(options) {
            if (!options.result.length) {
                options.result.push({ is_passed: true });
            } else if (options.result[0].is_passed) {
                options.result[0].is_passed = false;
            } else {
                options.result[0].is_passed = true;
            }
        }
        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );

        /**
         *  Created
         */

        return {
            state,
            UPDATE_TEST_QUESTIONS,
            GET_SLIDE,
            handleCheckboxChange,
        };
    },
});
</script>
